import { AfterViewChecked, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as feather from 'feather-icons';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, Observable, Subject } from 'rxjs';
import { Plan } from '../common/models/plan';
import { User } from '../common/models/user';
import { SharedService } from '../common/services/shared.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { PlanEditService } from '../common/services/plan-edit.service';
import { ConfirmationDialogComponent, ConfirmDialog } from '../dialogs/dialog-unsaved-changes/confirmation-dialog.component';
import { MatSidenav } from '@angular/material/sidenav';
import { DialogConfirmProfileComponent } from '../dialogs/dialog-confirm-profile/dialog-confirm-profile.component';
import { MsalService } from '@azure/msal-angular';
import { SessionTimeoutService } from '../common/services/session-timeout.service';


@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    standalone: false
})
export class LayoutComponent implements AfterViewChecked, OnInit, OnDestroy {

  User: Observable<User>;
  CurrentPlan: Observable<Plan>;
  isMobile: Observable<boolean>;
  isCollapsed = true;
  Plans: Observable<Plan[]>;

  firstPlan = true;
  secondPlan = false;
  thirdPlan = false;
  remainingTime$: Observable<number | null>;
  // the ViewChild decorator is used to get a reference to the sidenav component in the HTML template
  @ViewChild('sidenav', { static: true }) sidenav!: MatSidenav;

  destroy$ = new Subject<void>;

  constructor(private breakpointObserver: BreakpointObserver, private sharedService: SharedService, private dialog: MatDialog, private planEditService: PlanEditService, private authService: MsalService, public sessionTimer: SessionTimeoutService) { }

  ngOnInit(): void {
    this.isMobile = this.breakpointObserver.observe('(min-width: 480px)')
      .pipe(map(({ matches }) => (matches ? true : false)));
    this.User = this.sharedService.user$;
    this.CurrentPlan = this.sharedService.plan$;
    this.Plans = this.sharedService.plans$;
    this.User.subscribe({next: (u) => {
      if(u?.ShowProfileConfirmation)
        this.openConfirmationModal();
    }});
    this.remainingTime$ = this.sessionTimer.remainingSeconds$;
  }

  setNavBar(){
    this.isMobile.subscribe((mobile) => {
      if(!mobile){
        this.sidenav.toggle();
      }
    });
  }

  ngAfterViewChecked() {
    feather.replace();
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }

  return() {
    const returnConfirm = new ConfirmDialog();
    returnConfirm.title = "Return to Lawyer Portal";
    returnConfirm.message = "Are you sure you want to exit and return to the Alberta Lawyer Portal?"
    returnConfirm.okButtonTitle = "Return to Alberta Lawyer Portal";
    returnConfirm.cancelButtonTitle = "Cancel";
    const returnDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '430px',
      panelClass: 'pending-changes',
      data: returnConfirm,
      ariaLabelledBy: 'confirm-desc',
      disableClose: true
    });
    returnDialogRef.afterClosed().subscribe((result) => {
      if(result === 'ok') {
        this.planEditService.clear();
        window.location.href = environment.PortalURL;
      }
    });
  }

  logout() {
    const isEditing = this.planEditService.getIsEditing();
    const logoutConfirm = new ConfirmDialog();
    logoutConfirm.title = "Log Out";
    logoutConfirm.message = "Are you sure you want to log out of the CPD Tool and the Lawyer Portal?"
    if(isEditing) {
      logoutConfirm.message2 = "Your progress on this page will not be saved.";
    }
    else {
      logoutConfirm.message2 = null;
    }
    logoutConfirm.okButtonTitle = "Log out";
    logoutConfirm.cancelButtonTitle = "Cancel";
    const logoutDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '430px',
      panelClass: 'pending-changes',
      data: logoutConfirm,
      ariaLabelledBy: 'confirm-desc',
      disableClose: true
    });
    logoutDialogRef.afterClosed().subscribe((result) => {
      if(result === 'ok') {
        this.authService.logout();
      }
    });
  }

  openConfirmationModal(): void {
    this.dialog.open(DialogConfirmProfileComponent, {
      width: '848px',
      height: '792px',
      autoFocus: false,
      ariaLabelledBy: 'labelref'
    });
  }

  navBarStatus(){
  this.isCollapsed = !this.isCollapsed;
  }

  toggleMenu(id: string){
    if(id === "firstPlan")
      this.firstPlan = !this.firstPlan;
    if(id === "secondPlan")
      this.secondPlan = !this.secondPlan;
    if(id === "thirdPlan")
      this.thirdPlan = !this.thirdPlan;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
